import { render } from "./WriteMail.vue?vue&type=template&id=6ea97f84&scoped=true"
import script from "./WriteMail.vue?vue&type=script&lang=js"
export * from "./WriteMail.vue?vue&type=script&lang=js"

import "./WriteMail.vue?vue&type=style&index=0&id=6ea97f84&lang=less&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ea97f84"]])

export default __exports__